/*
 * Public API Surface of ui
 */

export * from './partials/partials.module';
